var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.is_ready
    ? _c(
        "div",
        { staticClass: "form-master", attrs: { id: "form-master" } },
        [
          _c(
            "b-row",
            _vm._l(_vm.dataFields, function(field, index) {
              return _c(
                "b-col",
                { key: index, attrs: { md: field.grid } },
                [
                  field.type === "text" &&
                  !field.is_delete &&
                  !_vm.formProperties[field.field_ui_key].is_hidden
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.formData[String(field.field_ui_key)]
                                .$error || field.error_input
                          }
                        },
                        [
                          _c("label", { staticClass: "label-form-base" }, [
                            _vm._v(" " + _vm._s(field.name) + " "),
                            field.is_mandatory
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "tooltips" },
                            [
                              _c("j-input", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.formData[String(field.field_ui_key)]
                                      .$error,
                                  id: "base-" + index,
                                  disabled:
                                    field.is_editable ||
                                    _vm.isDisabled ||
                                    _vm.formProperties[field.field_ui_key]
                                      .is_disable,
                                  placeholder: field.placeholder
                                },
                                model: {
                                  value:
                                    _vm.$v.formData[String(field.field_ui_key)]
                                      .$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.formData[
                                        String(field.field_ui_key)
                                      ],
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.formData[String(field.field_ui_key)].$model"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  field.type === "number" &&
                  !field.is_delete &&
                  !_vm.formProperties[field.field_ui_key].is_hidden
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.formData[String(field.field_ui_key)]
                                .$error || field.error_input
                          }
                        },
                        [
                          _c("label", { staticClass: "label-form-base" }, [
                            _vm._v(" " + _vm._s(field.name) + " "),
                            field.is_mandatory
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required":
                                _vm.$v.formData[String(field.field_ui_key)]
                                  .$error,
                              id: "base-" + index,
                              disabled:
                                field.is_editable ||
                                _vm.isDisabled ||
                                _vm.formProperties[field.field_ui_key]
                                  .is_disable,
                              placeholder: field.placeholder,
                              type: "number"
                            },
                            model: {
                              value:
                                _vm.$v.formData[String(field.field_ui_key)]
                                  .$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.formData[String(field.field_ui_key)],
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.formData[String(field.field_ui_key)].$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  field.type === "number_decimal" &&
                  !field.is_delete &&
                  !_vm.formProperties[field.field_ui_key].is_hidden
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.formData[String(field.field_ui_key)]
                                .$error || field.error_input
                          }
                        },
                        [
                          _c("label", { staticClass: "label-form-base" }, [
                            _vm._v(" " + _vm._s(field.name) + " "),
                            field.is_mandatory
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required":
                                _vm.$v.formData[String(field.field_ui_key)]
                                  .$error,
                              id: "base-" + index,
                              disabled:
                                field.is_editable ||
                                _vm.isDisabled ||
                                _vm.formProperties[field.field_ui_key]
                                  .is_disable,
                              placeholder: field.placeholder,
                              type: "number"
                            },
                            model: {
                              value:
                                _vm.$v.formData[String(field.field_ui_key)]
                                  .$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.formData[String(field.field_ui_key)],
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.formData[String(field.field_ui_key)].$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  field.type === "descriptive" &&
                  !field.is_delete &&
                  !_vm.formProperties[field.field_ui_key].is_hidden
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.formData[String(field.field_ui_key)]
                                .$error || field.error_input
                          }
                        },
                        [
                          _c("label", { staticClass: "label-form-base" }, [
                            _vm._v(" " + _vm._s(field.name) + " "),
                            field.is_mandatory
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("j-textarea", {
                            attrs: {
                              "error-required":
                                _vm.$v.formData[String(field.field_ui_key)]
                                  .$error,
                              disabled:
                                field.is_editable ||
                                _vm.isDisabled ||
                                _vm.formProperties[field.field_ui_key]
                                  .is_disable,
                              id: "base-" + index,
                              placeholder: field.placeholder
                            },
                            model: {
                              value:
                                _vm.$v.formData[String(field.field_ui_key)]
                                  .$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.formData[String(field.field_ui_key)],
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.formData[String(field.field_ui_key)].$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  field.type === "date_time" &&
                  !field.is_delete &&
                  !_vm.formProperties[field.field_ui_key].is_hidden
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.formData[String(field.field_ui_key)]
                                .$error || field.error_input
                          }
                        },
                        [
                          _c("label", { staticClass: "label-form-base" }, [
                            _vm._v(_vm._s(field.name) + " "),
                            field.is_mandatory
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("j-date-time", {
                            attrs: {
                              type: "datetime",
                              data:
                                _vm.$v.formData[String(field.field_ui_key)]
                                  .$model,
                              "error-required":
                                _vm.$v.formData[String(field.field_ui_key)]
                                  .$error,
                              disabled:
                                field.is_editable ||
                                _vm.isDisabled ||
                                _vm.formProperties[field.field_ui_key]
                                  .is_disable,
                              "min-datetime":
                                field.config &&
                                field.config.is_disable_back_date
                                  ? _vm.getDateToday()
                                  : null,
                              placeholder: field.placeholder,
                              id: "base-" + index
                            },
                            on: {
                              getTimestamp: function($event) {
                                _vm.setValueDate($event, field)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  field.type === "toggle" &&
                  !field.is_delete &&
                  !_vm.formProperties[field.field_ui_key].is_hidden
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.formData[String(field.field_ui_key)]
                                .$error || field.error_input
                          }
                        },
                        [
                          _c("label", { staticClass: "label-form-base" }, [
                            _vm._v(_vm._s(field.name) + " "),
                            field.is_mandatory
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("j-toggle", {
                            staticClass: "toggle-form-base",
                            attrs: {
                              id: "base-" + index,
                              disabled:
                                field.is_editable ||
                                _vm.isDisabled ||
                                _vm.formProperties[field.field_ui_key]
                                  .is_disable
                            },
                            model: {
                              value:
                                _vm.$v.formData[String(field.field_ui_key)]
                                  .$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.formData[String(field.field_ui_key)],
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.formData[String(field.field_ui_key)].$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            })
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d355986c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d355986c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-base/jFormBase.vue
// module id = null
// module chunks = 